import { combine, compute, dedupe } from '@exodus/atoms';
import { uniq } from 'lodash';
const getNetworks = (assetNames, assets) => uniq(assetNames
    .map((assetName) => assets[assetName]?.baseAsset.name)
    .filter((assetName) => !!assetName && !assets[assetName].isCombined));
const createBaseAssetNamesToMonitorAtom = ({ assetsModule, enabledAndDisabledAssetsAtom, isTxLogMonitorsSingleTickAtom, availableAssetNamesAtom, }) => {
    const selector = ({ isTxLogMonitorsSingleTick, enabledAndDisabledAssets, availableAssetNames, }) => {
        const assetNames = availableAssetNames.filter((assetName) => {
            if (isTxLogMonitorsSingleTick) {
                // Exclude disabled assets (e.g. testnets when Developer Mode is false).
                return enabledAndDisabledAssets.disabled[assetName] !== true;
            }
            // Include enabled assets only.
            return enabledAndDisabledAssets.disabled[assetName] === false;
        });
        return getNetworks(assetNames, assetsModule.getAssets());
    };
    return dedupe(compute({
        atom: combine({
            isTxLogMonitorsSingleTick: isTxLogMonitorsSingleTickAtom,
            enabledAndDisabledAssets: enabledAndDisabledAssetsAtom,
            availableAssetNames: availableAssetNamesAtom,
        }),
        selector,
    }));
};
const baseAssetNamesToMonitorAtomDefinition = {
    id: 'baseAssetNamesToMonitorAtom',
    type: 'atom',
    factory: createBaseAssetNamesToMonitorAtom,
    dependencies: [
        'assetsModule',
        'availableAssetNamesAtom',
        'enabledAndDisabledAssetsAtom',
        'isTxLogMonitorsSingleTickAtom',
    ],
};
export default baseAssetNamesToMonitorAtomDefinition;
